import * as ko from "knockout";
import entityBase from "entityBase";
import * as _ from "lodash";
import { CustomObservables } from "app/custom-observables";

export class MeterReadingContract extends entityBase {
  contract_id: KnockoutObservable<string>;
  contract_version: KnockoutObservable<string>;
  contract_name: KnockoutObservable<string>;
  contract_status: KnockoutObservable<string>;
  start_dt: KnockoutComputed<string>;
  end_dt: KnockoutComputed<string>;
  contract_type: KnockoutObservable<string>;
  approval_status: KnockoutObservable<string>;
  hist_meter_readings_num: KnockoutObservable<number>;
  meter_readings_num: KnockoutObservable<number>;
  name1: KnockoutObservable<string>;

  constructor(item) {
    super();
    this.contract_id = ko.observable(item.contract_id);
    this.contract_version = ko.observable(item.contract_version);
    this.contract_name = ko.observable(item.contract_name);
    this.contract_status = ko.observable(item.contract_status);
    this.start_dt = CustomObservables.formattedDateObservable(ko.observable(item?.start_dt));
    this.end_dt = CustomObservables.formattedDateObservable(ko.observable(item?.end_dt));
    this.contract_type = ko.observable(item.contr_type);
    this.approval_status = ko.observable(item.approval_status);
    this.hist_meter_readings_num = ko.observable(0);
    this.meter_readings_num = ko.observable(0);
    if (item.c_meter_readings_interim) {
      let historical = 0;
      let not_historical = 0;
      if (Array.isArray(item.c_meter_readings_interim)) {
        _.each(item.c_meter_readings_interim, (o) => {
          if (o.customer_status != "SUBMITTED") not_historical++;
          else historical++;
        });
      } else {
        if (item.c_meter_readings_interim.customer_status != "SUBMITTED") {
          not_historical++;
        } else {
          historical++;
        }
      }

      this.hist_meter_readings_num = ko.observable(historical);
      this.meter_readings_num = ko.observable(not_historical);
    }
    this.name1 = ko.observable();
    if (item.c_contract_places_view) {
      if (Array.isArray(item.c_contract_places_view)) {
        this.name1 = ko.observable(item.c_contract_places_view[0].name1);
      } else {
        this.name1 = ko.observable(item.c_contract_places_view.name1);
      }
    }
  }
}
